// extracted by mini-css-extract-plugin
export default {"linkText":"NavbarLink_linkText__snQnz","linkContainer":"NavbarLink_linkContainer__S5ciz"};